module.exports = __webpack_public_path__ + "static/media/navigatorc84faf7d5d50f852a52d3619c0aa98bb.webp";